import { AxiosResponse } from 'axios';
import Api from './api';

const DocumentRemoveApi = (data: any): Promise<AxiosResponse> => {
  const path = '/admin/doc/delete';
  return Api.getInstance().request.put(path, data);
};

export default DocumentRemoveApi;
